import { render, staticRenderFns } from "./VerDetalleDispositivoModal.vue?vue&type=template&id=36f981be&"
import script from "./VerDetalleDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('36f981be', component.options)
    } else {
      api.reload('36f981be', component.options)
    }
    module.hot.accept("./VerDetalleDispositivoModal.vue?vue&type=template&id=36f981be&", function () {
      api.rerender('36f981be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/VerDetalleDispositivoModal.vue"
export default component.exports